var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-header .logo-header .navbar-toggler .navbar-toggler-icon {\n  background: url(" + escape(require("assets/img/menu2.png")) + ");\n  background-size: cover;\n  height: 1em;\n  width: 1em;\n  opacity: .8; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layouts/site-header/site-header.component.scss
// module id = ../../../../../src/app/layouts/site-header/site-header.component.scss
// module chunks = main